function Payments() {
  this.init = function () {

    this.validateStep3();
    this.bindEvents();

  }

  this.validateStep3 = function () {

    $.validator.addMethod('CCExp', function(value) {
      if (!value) return false;

      var parts = value.split("/");
      if (parts.length !== 2) return false;

      var month = parseInt(parts[0], 10);
      var year = parseInt(parts[1], 10);

      if (!month || !year) return false;

      var now = new Date();
      var currentMonth = now.getMonth() + 1;
      var currentYear = parseInt(now.getFullYear().toString().substr(-2), 10);

      return (year > currentYear || (year === currentYear && month >= currentMonth));
    }, 'Expiry must be in the future');

    var formHasBeenSubmitted = false;

    $("#payments").validate({

      ignore: ":hidden",
      onkeyup: false,

      highlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          $(element)
            .closest('.donation-group')
            .addClass('invalid');
        } else {
          $(element)
            .closest('.text-input')
            .addClass('invalid');
        }
      },

      unhighlight: function(element) {
        if (!formHasBeenSubmitted) return;

        if (element.type === "radio") {
          var group = $(element).closest('.donation-group');

          // only mark valid if one is checked
          if ($('input[name="' + element.name + '"]:checked').length) {
            group.removeClass('invalid');
          }
        } else {
          $(element)
            .closest('.text-input')
            .removeClass('invalid');
        }
      },

      /*  ios8 & above only scroll back to the focus of the first error. If you hit submit again & there is another error
          it will not scroll. This confuses the user as they do not think there is another error message. This code fixes that. */
      invalidHandler: function(e, validator) {
        formHasBeenSubmitted = true;

        if (window.navigator.userAgent.match(/iphone/i)) {
          window.setTimeout(function() {

            var el = $(validator.errorList[0].element);

            var target = el.attr("type") === "radio"
              ? el.closest('.donation-group')
              : el;

            $("html,body").animate({
              scrollTop: target.offset().top
            });

          }, 0);
        }
      },

      errorPlacement: function(error, element) {
        error.addClass('input-error caption');

        if (element.attr("type") === "radio") {
          error.insertAfter(element.closest('.donation-group'));
        } else if (element.attr("type") === "checkbox") {
          error.insertAfter(element.closest('.switch'));
        } else {
          var wrapper = element.closest('.text-input-wrapper');
          var description = wrapper.find('.input-description');

          if (description.length) {
            error.insertBefore(description);
          } else {
            wrapper.append(error);
          }
        }
      },

      rules: {
        cardNumber: {
          normalizer: function(value) {
            return this.value.replace(/ /g,'');
          },
          creditcard: true
        },
        expiry: {
          required: true,
          minlength: 5,
          pattern: /^(0[1-9]|1[0-2])\/\d{2}$/,
          CCExp: true
        },
        agree_tc: {
          required: true
        }
      },

      messages: {
        cardNumber: {
          required: 'Enter the long number on the front of the card',
          minlength: 'Card number must be 13 characters or more',
          creditcard: 'Enter a valid credit card number'
        },
        expiry: {
          required: 'Enter expiry date',
          minlength: 'Enter expiry as MM/YY',
          pattern: 'Enter a valid expiry like 09/27',
          CCExp: 'Expiry must be in the future'
        },
        cardName: {
          required: 'Enter the full name on front of the card'
        },
        cardSecurityCode: {
          required: 'Enter the card security code',
          minlength: 'Card security code must be 3 or 4 characters',
          pattern: 'Card security code must be a number'
        },
        agree_tc: {
          required: 'Please accept the terms and conditions to continue'
        }
      },

      submitHandler: function(form) {

        // Remove back button
        $("#step2-submit-div").find("button[type='button']").remove();

        var $btn = $("#submit-btn");
        $btn
          .addClass("w-100")
          .prop("disabled", true)
          .addClass("is-loading");

        grecaptcha.ready(function() {
          grecaptcha.execute('6LeP_rkUAAAAAO2GHVS31IwO4Zquu0aA7F0ZSYpc', {action: 'homepage'}).then(function(token) {
            jQuery('#payments').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
            form.submit();
          });
        });

      }

    });

  }

  this.bindEvents = function () {

    /* Make sure the enter key is not used to submit */
    $("#payments").on("keypress", function (event) {
      var keyPressed = event.keyCode || event.which;
      if (keyPressed === 13) {
          event.preventDefault();
          return false;
      }
    });

    $("#expiry").on("input", function (e) {
      var input = this;
      var value = input.value;

      // Detect if deleting
      var isDeleting = e.originalEvent && e.originalEvent.inputType === "deleteContentBackward";

      // Allow user to type slash manually
      var clean = value.replace(/[^\d\/]/g, "");

      // Handle case like "1/27"
      if (clean.indexOf("/") > -1) {
        var parts = clean.split("/");

        var m = parts[0] || "";
        var y = parts[1] || "";

        // 👉 limit lengths
        m = m.substring(0, 2);
        y = y.substring(0, 2);

        // Auto pad month if single digit
        if (m.length === 1) {
          m = "0" + m;
        }

        input.value = m + "/" + y;

        $("#cc_expiry_month").val(m);
        $("#cc_expiry_year").val(y);

        return;
      }

      // Otherwise, digits-only formatting
      var digits = clean.replace(/\D/g, "").substring(0, 4);

      // Handle backspace properly (don’t force slash)
      if (isDeleting) {
        input.value = digits;
        
        $("#cc_expiry_month").val(digits.substring(0, 2) || "");
        $("#cc_expiry_year").val(digits.substring(2, 4) || "");

        return;
      }

      // Auto format
      if (digits.length >= 2) {
        input.value = digits.substring(0, 2) + "/" + digits.substring(2);
      } else {
        input.value = digits;
      }

      $("#cc_expiry_month").val(digits.substring(0, 2) || "");
      $("#cc_expiry_year").val(digits.substring(2, 4) || "");
    });

    // Disables payment options until T&C agreed
    const $submitBtn = $('button[type="submit"]');
    
    $('#agree_tc').on('click', function () {
      if (this.checked) {
        $("input[name=payment_method]").prop("disabled", false);

        $('.payment_types').show();

        $("#payment_method_cc")
          .prop('checked', true)
          .trigger('change');

        $submitBtn.removeClass('is-hidden');

      } else {
        $("input[name=payment_method]").prop("disabled", true);
        $("input[name=payment_method]").prop('checked', false);

        $('.payment_types').hide();
        $('.payment_types_cc').hide();
        $('.payment_types_paypal').hide();

        $submitBtn.addClass('is-hidden');
      }
    });

    $('input[name="payment_method"]').on('change', function () {
      var method = $(this).val();

      if (method === 'paypal') {
        $('#card-fields').hide();
        $('#paypal-fields').show();
       $submitBtn.addClass('is-hidden');
      } else {
        $('#card-fields').show();
        $('#paypal-fields').hide();
        $submitBtn.removeClass('is-hidden');
      }
    });
    

    $("input[name='payment_frequency']").change(function(){

      var payment_frequency = $(this).val();

      $.ajax({
        method: "POST",
        url: "/ajaxFunctions.cgi",
        data: { 
          id: $("#id").val(),
          s: $("#s").val(),
          tier: $("#tier").val(),
          payment_frequency: payment_frequency,
          action: 'checkout_total' }
      }) 
        .done(function( data ) {
          $("#membership_label").text(data.amount_dollars.membership_label);
          $("#membership_cost").text('$' + data.amount_dollars.membership);
          $(".checkout_total").text('$' + data.amount_dollars.checkout_total);
        })
        .fail(function(x) {
          console.log(x);
      });

    });

  }

}

module.exports = Payments;
